import React from "react";
import Header from "./Header/Header"; 
import Footer from "./Footer/footer"; 
import ".//PrivacyPolicy/PrivacyPolicy.css";
const Terms = () => {
  return (
    <>
      <Header />
      <div className="privacy-container">
        <h1 className="privacy-title">Terms of Use</h1>
        <div className="privacy-content">
          <p>
        <b> 1. Acceptance of Terms</b> <br />
By using our website and services, you agree to comply with these Terms of Service. If you do
not agree, you may not use our services.<br /><br /><br />
<b>2. Eligibility<br /></b>
You must be at least 18 years old to register for Project Black.<br /><br />
<b>3. Use of Services<br /></b>
● You agree to use our platform lawfully and not engage in fraudulent activities.<br />
● Any misuse or unauthorized access to our services may result in termination.<br /><br />
<b>4. Payments & Subscriptions<br /></b>
● Fees for services are non-refundable unless otherwise stated.<br />
● Subscription-based services may require recurring payments.<br /><br />
<b>5. Intellectual Property<br /></b>
● All content on Project Black is owned by us or our partners and may not be copied,
distributed, or used without permission.<br /><br />
<b>6. Termination<br /></b>
● We reserve the right to terminate accounts that violate our policies.<br />
● Users may also terminate their accounts by contacting customer support.<br /><br />
<b>7. Limitation of Liability<br /></b>
● Project Black is not liable for indirect, incidental, or consequential damages resulting
from the use of our services.<br /><br />
<b>8. Changes to These Terms<br /></b>
We may update these Terms of Service periodically. Continued use of our services after
changes are posted constitutes acceptance of the new terms.<br /><br />
<b>9. Contact Us<br /></b>
For any inquiries regarding these Terms of Service, contact us at: Email:
billing@goprojectblack.com<br />
By using our website, you acknowledge that you have read, understood, and agreed to these
Terms of Service.<br />
          <br />
          
              </p>
                 </div>
      </div>
      <Footer />
    </>
  );
};

export default Terms;
